import { render } from "./indexreportDetail.vue?vue&type=template&id=d551fb1e&scoped=true&ts=true"
import script from "./indexreportDetail.vue?vue&type=script&lang=ts"
export * from "./indexreportDetail.vue?vue&type=script&lang=ts"

import "./indexreportDetail.vue?vue&type=style&index=0&id=d551fb1e&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d551fb1e"]])

export default __exports__